var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.24973C16.5318 2.75634 15.7366 3.14381 14.895 3.39723C14.4433 2.87786 13.843 2.50975 13.1753 2.34267C12.5076 2.1756 11.8046 2.21763 11.1616 2.46307C10.5185 2.70851 9.96633 3.14553 9.57974 3.71502C9.19314 4.2845 8.99077 4.95898 9 5.64723V6.39723C7.68198 6.43141 6.37596 6.13909 5.19826 5.54631C4.02056 4.95354 3.00774 4.07871 2.25 2.99973C2.25 2.99973 -0.75 9.74973 6 12.7497C4.4554 13.7982 2.61537 14.3239 0.75 14.2497C7.5 17.9997 15.75 14.2497 15.75 5.62473C15.75 5.41473 15.7275 5.20473 15.69 5.00223C16.4555 4.24735 16.9956 3.29426 17.25 2.24973V2.24973Z",
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.16a432120fd70c9d0b94da8c004890fb.svg";
export { ForwardRef as ReactComponent };